import safeQueryStringParse from './safe-query-string-parse';

export default (search) => {
  const parsedParams = safeQueryStringParse(search);

  const page = (parsedParams.p || '0') * 1 || 0;
  let facets;
  try {
    facets = JSON.parse(parsedParams.f);
  } catch (e) {
    facets = {};
  }
  return {
    searchTerm: parsedParams.q,
    page,
    facets,
    s: parsedParams.s,
  };
};
